import { render, staticRenderFns } from "./CapabilityCard.vue?vue&type=template&id=32c3253b&scoped=true"
import script from "./CapabilityCard.vue?vue&type=script&lang=js"
export * from "./CapabilityCard.vue?vue&type=script&lang=js"
import style0 from "./CapabilityCard.vue?vue&type=style&index=0&id=32c3253b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c3253b",
  null
  
)

export default component.exports